/* =========================================================
   Amarsiempre – tema Shopify
   Cabecera, menú lateral animado, búsqueda, carrito (API Ajax de Shopify),
   botón interactivo de agregar, página de producto y personalización.
   ========================================================= */
(function () {
  'use strict';

  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const CFG = window.AMAR || {};
  const R = CFG.rutas || {};
  const fmt = new Intl.NumberFormat(CFG.locale || 'es-MX', { style: 'currency', currency: CFG.moneda || 'MXN', currencyDisplay: 'narrowSymbol' });
  const money = (centavos) => fmt.format((centavos || 0) / 100).replace('MX', '');
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const norm = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  const quieto = matchMedia('(prefers-reduced-motion: reduce)');
  const ICON = {
    chevron: '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>'
  };
  const postJSON = (url, data) => fetch(url, {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data)
  }).then(async (r) => { const j = await r.json().catch(() => ({})); if (!r.ok) throw j; return j; });

  /* ---------- Toast ---------- */
  let tt;
  function toast(msg) {
    const t = $('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(tt);
    tt = setTimeout(() => t.classList.remove('is-visible'), 3400);
  }

  /* ---------- Barra de anuncio ---------- */
  (function () {
    const msgs = $$('.announcement__msg');
    if (msgs.length < 2) return;
    let i = 0, timer;
    const show = (n) => { msgs[i].classList.remove('is-active'); i = (n + msgs.length) % msgs.length; msgs[i].classList.add('is-active'); };
    const auto = () => { clearInterval(timer); timer = setInterval(() => show(i + 1), 5000); };
    $$('[data-ann]').forEach((b) => b.addEventListener('click', () => { show(i + Number(b.dataset.ann)); auto(); }));
    auto();
  })();

  /* ---------- Cabecera que se esconde al bajar ---------- */
  (function () {
    const h = $('[data-header]');
    if (!h) return;
    const wrap = h.closest('.shopify-section') || h;
    wrap.classList.add('section-header');
    let last = scrollY;
    addEventListener('scroll', () => {
      const y = scrollY;
      wrap.classList.toggle('is-hidden', y > last && y > 260 && !document.body.classList.contains('no-scroll'));
      last = y;
    }, { passive: true });
  })();

  /* ---------- Menú lateral: coreografía de la referencia ----------
     Abrir: opciones una a una (sube 8px, 0.15s, 0.1s entre cada una).
     Desplegable: la lista se difumina 10px a la izquierda (0.25s), entra el panel (0.3s) y sus palabras aparecen una a una.
     Volver: el panel se difumina 10px a la derecha (0.3s) y a los 0.5s la lista reaparece palabra a palabra. */
  const menu = (function () {
    const main = $('[data-side-main]'), panel = $('[data-side-panel]');
    if (!main || !panel) return { alAbrir() {}, alCerrar() {} };
    const anim = (el, kf, s, retraso) => el.animate(kf, {
      duration: quieto.matches ? 0 : s * 1000, delay: quieto.matches ? 0 : (retraso || 0) * 1000, easing: 'ease', fill: 'both' });
    const escalonar = (els, desde) => els.forEach((el, i) => anim(el, { opacity: [0, 1], transform: ['translateY(8px)', 'translateY(0)'] }, 0.15, desde + i * 0.1));
    const limpiar = (el) => el.getAnimations({ subtree: true }).forEach((a) => a.cancel());
    function revelarPrincipal(retraso) {
      limpiar(main);
      anim(main, { opacity: [0, 1], transform: ['translateX(0)', 'translateX(0)'] }, 0, retraso);
      const items = $$('.side__list > li', main);
      escalonar(items, retraso);
      const pie = $('.side__foot', main);
      if (pie) anim(pie, { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)'] }, 0.3, retraso + items.length * 0.1 + 0.05);
    }
    function abrirSub(boton) {
      $$('[aria-controls]', main).forEach((b) => b.setAttribute('aria-expanded', String(b === boton)));
      limpiar(main);
      anim(main, { opacity: [1, 0], transform: ['translateX(0)', 'translateX(-10px)'] }, 0.25);
      main.inert = true;
      $$('.side__sub', panel).forEach((s) => { s.hidden = s.id !== boton.getAttribute('aria-controls'); });
      const sub = document.getElementById(boton.getAttribute('aria-controls'));
      panel.hidden = false;
      limpiar(panel);
      anim(panel, { opacity: [0, 1], transform: ['translateX(0)', 'translateX(0)'] }, 0.3);
      escalonar([$('.side__back', sub)].concat($$('.side__list > li', sub)), 0);
      setTimeout(() => $('.side__back', sub).focus({ preventScroll: true }), 50);
    }
    function volver() {
      const abierto = $('[aria-expanded="true"]', main);
      limpiar(panel);
      anim(panel, { opacity: [1, 0], transform: ['translateX(0)', 'translateX(10px)'] }, 0.3).finished.then(() => { panel.hidden = true; }).catch(() => {});
      $$('[aria-controls]', main).forEach((b) => b.setAttribute('aria-expanded', 'false'));
      main.inert = false;
      revelarPrincipal(0.5);
      if (abierto) setTimeout(() => abierto.focus({ preventScroll: true }), 500);
    }
    $$('[aria-controls]', main).forEach((b) => b.addEventListener('click', () => abrirSub(b)));
    $$('[data-side-back]', panel).forEach((b) => b.addEventListener('click', volver));
    let reset;
    return {
      alAbrir() {
        clearTimeout(reset); limpiar(panel); panel.hidden = true; main.inert = false;
        $$('[aria-controls]', main).forEach((b) => b.setAttribute('aria-expanded', 'false'));
        revelarPrincipal(0.2);
      },
      alCerrar() {
        clearTimeout(reset);
        reset = setTimeout(() => { limpiar(panel); limpiar(main); panel.hidden = true; main.inert = false;
          $$('[aria-controls]', main).forEach((b) => b.setAttribute('aria-expanded', 'false')); }, 350);
      }
    };
  })();

  /* ---------- Drawers (menú, carrito, búsqueda) ---------- */
  const overlay = $('[data-overlay]');
  let abierto = null;
  function abrir(nombre) {
    cerrar();
    abierto = $('[data-drawer="' + nombre + '"]');
    if (!abierto) return;
    abierto.classList.add('is-open');
    abierto.setAttribute('aria-hidden', 'false');
    overlay && overlay.classList.add('is-visible');
    document.body.classList.add('no-scroll');
    if (nombre === 'search') setTimeout(() => { const i = $('[data-search-input]'); i && i.focus(); }, 50);
    if (nombre === 'menu') menu.alAbrir();
  }
  function cerrar() {
    if (!abierto) return;
    if (abierto.dataset.drawer === 'menu') menu.alCerrar();
    abierto.classList.remove('is-open');
    abierto.setAttribute('aria-hidden', 'true');
    overlay && overlay.classList.remove('is-visible');
    document.body.classList.remove('no-scroll');
    abierto = null;
  }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open]');
    if (o) {
      // En la página del carrito, el icono lleva a la página completa
      if (o.dataset.open === 'cart' && document.body.classList.contains('plantilla-cart')) return;
      e.preventDefault();
      abrir(o.dataset.open);
    }
    if (e.target.closest('[data-close]')) cerrar();
  });
  overlay && overlay.addEventListener('click', cerrar);
  // Con una foto abierta (dialog), Escape solo cierra la foto
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !$('dialog[open]')) cerrar(); });

  /* ---------- Búsqueda predictiva ---------- */
  (function () {
    const inp = $('[data-search-input]'), res = $('[data-search-results]');
    if (!inp || !res || !R.sugerencias) return;
    let ctrl, timer;
    inp.addEventListener('input', () => {
      clearTimeout(timer);
      const q = inp.value.trim();
      if (q.length < 2) { res.innerHTML = ''; return; }
      timer = setTimeout(() => {
        ctrl && ctrl.abort();
        ctrl = new AbortController();
        fetch(R.sugerencias + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', { signal: ctrl.signal })
          .then((r) => r.json())
          .then((d) => {
            const prods = (d.resources && d.resources.results && d.resources.results.products) || [];
            const todos = '/search?type=product&q=' + encodeURIComponent(q);
            res.innerHTML = prods.length
              ? '<p class="search-results__label">Productos</p><div class="search-results__list">' + prods.map((p) =>
                '<a href="' + p.url + '">' + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') +
                '<span>' + esc(p.title) + '<small>' + esc(p.price) + '</small></span></a>').join('') +
                '</div><a class="search-results__all" href="' + todos + '">Ver todos los resultados de "' + esc(q) + '" ' + ICON.arrow + '</a>'
              : '<p class="search-results__label">No hay resultados para "' + esc(q) + '"</p>';
          }).catch(() => {});
      }, 200);
    });
  })();

  /* ---------- Temporizador de reserva del carrito ---------- */
  const reserva = (function () {
    const KEY = 'amarsiempre_reserva';
    const leer = () => { try { return Number(localStorage.getItem(KEY)) || 0; } catch (e) { return 0; } };
    const guardar = (v) => { try { v ? localStorage.setItem(KEY, String(v)) : localStorage.removeItem(KEY); } catch (e) { /* sin almacenamiento */ } };
    let fin = leer();
    return {
      reiniciar() { if (fin <= Date.now()) { fin = Date.now() + (CFG.reservaMinutos || 5) * 60000; guardar(fin); } },
      limpiar() { fin = 0; guardar(0); },
      restante() { return Math.max(0, Math.floor((fin - Date.now()) / 1000)); }
    };
  })();
  function tic() {
    const el = $('[data-cart-timer]');
    if (!el) return;
    const s = reserva.restante();
    if (!s) reserva.reiniciar();
    const r = reserva.restante();
    $('[data-timer]', el).textContent = String(Math.floor(r / 60)).padStart(2, '0') + ':' + String(r % 60).padStart(2, '0');
  }
  setInterval(tic, 1000);

  /* ---------- Carrito (Section Rendering API) ---------- */
  const carrito = {
    ultimoVariante: null,
    async refrescar() {
      const url = (location.pathname.indexOf('/cart') === 0 ? R.raiz : location.pathname) + '?sections=cart-drawer';
      const data = await fetch(url).then((r) => r.json());
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const nuevo = $('[data-drawer="cart"]', html);
      const actual = $('[data-drawer="cart"]');
      if (!nuevo || !actual) return;
      $('.drawer__panel', actual).innerHTML = $('.drawer__panel', nuevo).innerHTML;
      const n = Number(nuevo.dataset.cartCountValue || 0);
      actual.dataset.cartCountValue = n;
      $$('[data-cart-count]').forEach((el) => {
        const antes = Number(el.textContent) || 0;
        el.textContent = n;
        el.hidden = !n;
        if (n > antes) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
      });
      if (!n) reserva.limpiar();
      if (this.ultimoVariante) {
        const fila = $('.cart-item[data-variant="' + this.ultimoVariante + '"]', actual);
        fila && fila.classList.add('is-new');
        this.ultimoVariante = null;
      }
      tic();
      document.dispatchEvent(new CustomEvent('amar:carrito'));
    },
    tiene(variante) { return !!$('[data-drawer="cart"] .cart-item[data-variant="' + variante + '"]'); },
    async cambiar(key, cantidad) {
      await postJSON(R.cartChange, { id: key, quantity: cantidad });
      await this.refrescar();
    },
    async agregar(items, boton, opciones = {}) {
      if (boton) { boton.classList.add('is-loading'); boton.disabled = true; boton.setAttribute('aria-busy', 'true'); }
      const inicio = Date.now();
      try {
        if (opciones.formData) {
          const resp = await fetch(R.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: opciones.formData });
          if (!resp.ok) throw await resp.json().catch(() => ({}));
          if (items.length > 1) await postJSON(R.cartAdd, { items: items.slice(1) });
        } else {
          await postJSON(R.cartAdd, { items });
        }
        // Envío protegido preseleccionado: aparte, para que un fallo suyo nunca impida agregar el producto
        const p = proteccion.estado();
        if (p && !p.key && !p.off && !items.some((i) => Number(i.id) === p.variante)) {
          await postJSON(R.cartAdd, { items: [{ id: p.variante, quantity: 1 }] }).catch(() => {});
        }
        reserva.reiniciar();
        this.ultimoVariante = items[0].id;
        await this.refrescar();
        // Mantiene la animación de carga visible un instante, como la referencia
        const espera = Math.max(0, 550 - (Date.now() - inicio));
        await new Promise((r) => setTimeout(r, espera));
        if (opciones.abrir !== false) abrir('cart');
        if (boton) {
          boton.classList.remove('is-loading'); boton.classList.add('is-done'); boton.removeAttribute('aria-busy');
          setTimeout(() => { boton.classList.remove('is-done'); boton.disabled = false; }, 1600);
        }
        return true;
      } catch (err) {
        if (boton) { boton.classList.remove('is-loading'); boton.disabled = false; boton.removeAttribute('aria-busy'); }
        toast((err && (err.description || err.message)) || 'No se pudo agregar al carrito. Inténtalo de nuevo.');
        return false;
      }
    }
  };
  window.AmarCarrito = carrito;

  /* ---------- Envío protegido (preseleccionado; se quita con el interruptor) ---------- */
  const proteccion = {
    intentado: false,
    estado() {
      const e = $('[data-drawer="cart"] [data-prot-estado]');
      return e && { variante: Number(e.dataset.variante), key: e.dataset.key, off: e.dataset.off === '1', reales: Number(e.dataset.reales) };
    },
    // Tras cada cambio: lo agrega si falta (carritos llenados por otra vía) o lo quita si se quedó solo. Devuelve true si cambió algo.
    async revisar() {
      const s = this.estado();
      if (!s) return false;
      if (!s.reales) {
        this.intentado = false;
        if (!s.key) return false;
        await postJSON(R.cartChange, { id: s.key, quantity: 0 });
      } else if (!s.key && !s.off && !this.intentado) {
        this.intentado = true;
        await postJSON(R.cartAdd, { items: [{ id: s.variante, quantity: 1 }] });
      } else return false;
      await carrito.refrescar();
      return true;
    },
    async cambiar(activar) {
      const s = this.estado();
      if (!s) return;
      await postJSON(R.cartUpdate, { attributes: { _sin_proteccion: activar ? '' : '1' } });
      if (activar && !s.key) await postJSON(R.cartAdd, { items: [{ id: s.variante, quantity: 1 }] });
      if (!activar && s.key) await postJSON(R.cartChange, { id: s.key, quantity: 0 });
      await carrito.refrescar();
    }
  };
  const enPaginaCarrito = !!$('[data-cart-page]');
  document.addEventListener('amar:carrito', () => { proteccion.revisar().catch(() => {}); });
  proteccion.revisar().then((cambio) => { if (cambio && enPaginaCarrito) location.reload(); }).catch(() => {});
  document.addEventListener('change', (e) => {
    const t = e.target.closest('[data-prot-toggle]');
    if (!t) return;
    t.disabled = true;
    proteccion.cambiar(t.checked)
      .then(() => { if (t.closest('[data-cart-page]')) location.reload(); })
      .catch(() => { t.checked = !t.checked; t.disabled = false; toast('No se pudo actualizar el envío protegido.'); });
  });

  // Foto de la reseña del carrito en grande (delegado: el cajón se vuelve a dibujar)
  document.addEventListener('click', (e) => {
    const abrir = e.target.closest('[data-resena-abrir]');
    if (abrir) { abrir.closest('.cart-resena').querySelector('[data-resena-dialogo]').showModal(); return; }
    const d = e.target.closest('[data-resena-dialogo]');
    if (d && (e.target === d || e.target.closest('[data-resena-cerrar]'))) d.close();
  });

  // Interacciones dentro del carrito lateral (delegadas: el contenido se vuelve a dibujar)
  const cajon = $('[data-drawer="cart"]');
  if (cajon) {
    cajon.addEventListener('click', async (e) => {
      const q = e.target.closest('[data-qty]');
      if (q) {
        const fila = q.closest('.cart-item');
        fila.style.opacity = '.5';
        try { await carrito.cambiar(fila.dataset.key, Number(q.dataset.qty)); } catch (err) { fila.style.opacity = ''; toast('No se pudo actualizar la cantidad.'); }
        return;
      }
      const u = e.target.closest('[data-upsell-add]');
      if (u) { carrito.agregar([{ id: Number(u.dataset.upsellAdd), quantity: 1 }], u, { abrir: false }); return; }
      const nt = e.target.closest('[data-note-toggle]');
      if (nt) {
        const n = $('[data-note]', cajon);
        n.hidden = !n.hidden;
        nt.setAttribute('aria-expanded', String(!n.hidden));
        if (!n.hidden) $('textarea', n).focus();
      }
    });
    cajon.addEventListener('change', (e) => {
      if (e.target.matches('[data-note-input]')) postJSON(R.cartUpdate, { note: e.target.value }).catch(() => {});
    });
    tic();
  }

  /* ---------- Acordeones con flecha ---------- */
  $$('details.accordion summary').forEach((s) => { if (!$('.accordion__chev', s)) s.insertAdjacentHTML('beforeend', '<span class="accordion__chev">' + ICON.chevron + '</span>'); });

  /* ---------- Colección: ordenar ---------- */
  $$('[data-sort]').forEach((sel) => sel.addEventListener('change', () => {
    const u = new URL(location.href);
    u.searchParams.set('sort_by', sel.value);
    u.searchParams.delete('page');
    location.href = u.toString();
  }));

  /* ---------- Carrusel de la portada ---------- */
  $$('.carousel').forEach((c) => {
    const track = $('[data-carousel]', c);
    $$('[data-car]', c).forEach((b) => b.addEventListener('click', () => track.scrollBy({ left: Number(b.dataset.car) * track.clientWidth, behavior: 'smooth' })));
  });

  /* ---------- Testimonios ---------- */
  $$('[data-testimonials]').forEach((sec) => {
    const items = $$('.testimonial', sec), dots = $$('.dots button', sec);
    if (items.length < 2) return;
    let i = 0, t;
    const ver = (n) => { i = (n + items.length) % items.length; items.forEach((e, k) => e.classList.toggle('is-active', k === i)); dots.forEach((e, k) => e.classList.toggle('is-active', k === i)); };
    const auto = () => { clearInterval(t); t = setInterval(() => ver(i + 1), 6000); };
    dots.forEach((b, k) => b.addEventListener('click', () => { ver(k); auto(); }));
    auto();
  });

  /* ---------- Pestañas Detalles / Envío / Garantía ---------- */
  $$('[data-ptabs]').forEach((w) => {
    const tabs = $$('[data-ptab]', w);
    tabs.forEach((t) => t.addEventListener('click', () => {
      tabs.forEach((x) => { const on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', String(on)); });
      $$('[data-ppanel]', w).forEach((p) => { p.hidden = p.dataset.ppanel !== t.dataset.ptab; });
    }));
  });

  /* ---------- Reseñas: cargar más ---------- */
  // Reseñas reales en 2 columnas sin huecos: cada tarjeta ocupa tantas filas de 2px como mide
  const apilarResenas = () => $$('.reviews-real .reviews__grid').forEach((g) => {
    g.classList.add('is-masonry');
    $$('.review:not([hidden])', g).forEach((r) => {
      r.style.gridRowEnd = `span ${Math.ceil((r.getBoundingClientRect().height + 10) / 2)}`;
    });
  });
  apilarResenas();
  if (document.fonts) document.fonts.ready.then(apilarResenas);
  window.addEventListener('resize', apilarResenas);
  $$('[data-more-reviews]').forEach((b) => b.addEventListener('click', () => {
    const sec = b.closest('[data-reviews]');
    const extra = $$('.review[hidden]', sec);
    extra.slice(0, 6).forEach((r) => { r.hidden = false; });
    apilarResenas();
    if (extra.length <= 6) {
      b.closest('.reviews__more').hidden = true;
      const fin = $('[data-reviews-end]', sec);
      if (fin) fin.hidden = false;
    }
  }));

  /* =========================================================
     Página de producto
     ========================================================= */
  const raiz = $('[data-product]');
  if (raiz) iniciarProducto(raiz);

  function iniciarProducto(root) {
    const datos = JSON.parse($('[data-product-json]').textContent);
    const form = $('[data-form]', root);
    const btn = $('.btn--atc', root);
    const idInput = $('[data-variant-id]', form);
    const pasos = $$('.step[data-opcion]', root);
    const persos = $$('[data-perso]', root);
    const extras = $$('[data-extra]', root);
    const PIEDRAS = [['ENE', 'Granate', '#8b1a2b'], ['FEB', 'Amatista', '#8e5bb5'], ['MAR', 'Aguamarina', '#8fd3e8'], ['ABR', 'Diamante', '#e9eef3'],
      ['MAY', 'Esmeralda', '#1f9e5a'], ['JUN', 'Alejandrita', '#c6a6d9'], ['JUL', 'Rubí', '#d0103a'], ['AGO', 'Peridoto', '#9ccc3b'],
      ['SEP', 'Zafiro', '#1f4fb8'], ['OCT', 'Turmalina', '#f2a5c0'], ['NOV', 'Topacio', '#f2a134'], ['DIC', 'Circón', '#3fb0d9']];

    // Gema en forma de gota con facetas (como la referencia)
    const gema = (color, i) =>
      '<svg class="gem" viewBox="0 0 24 30" aria-hidden="true"><defs><linearGradient id="gm' + i + '" x1="0" y1="0" x2="1" y2="1">' +
      '<stop offset="0" stop-color="#fff" stop-opacity=".75"/><stop offset=".35" stop-color="' + color + '"/><stop offset="1" stop-color="' + color + '" stop-opacity=".85"/></linearGradient></defs>' +
      '<path d="M12 1.5C15 6.5 21 11.5 21 19a9 9 0 01-18 0C3 11.5 9 6.5 12 1.5z" fill="url(#gm' + i + ')" stroke="rgba(0,0,0,.28)" stroke-width=".8"/>' +
      '<path d="M12 1.5L8.5 15 12 28M12 1.5L15.5 15 12 28M3.3 17.5L8.5 15h7l5.2 2.5M8.5 15L4.5 24M15.5 15l4 9" fill="none" stroke="rgba(255,255,255,.45)" stroke-width=".6"/>' +
      '<path d="M8.6 9.5C9.8 7.5 10.8 6 11.5 4.8" stroke="#fff" stroke-opacity=".9" stroke-width="1.2" stroke-linecap="round" fill="none"/></svg>';
    const piedrasGrid = (nombre, extraAttrs) =>
      '<div class="stones"' + (extraAttrs || '') + '>' + PIEDRAS.map(([mes, piedra, color], i) =>
        '<label class="stone" title="' + piedra + '"><input type="radio" name="' + nombre + '" value="' + mes + ' (' + piedra + ')"><span>' + gema(color, i) + mes + '</span></label>').join('') + '</div>';

    /* ---------- Opciones: círculos de color e imágenes ---------- */
    const desc = {};
    (datos.descripcionesOpciones || []).forEach((l) => { const i = l.indexOf('='); if (i > 0) desc[norm(l.slice(0, i))] = l.slice(i + 1).trim(); });
    const COLORES = [
      [/rosa|rose/, 'linear-gradient(135deg,#f6d3c4,#d99a83)'],
      [/vermeil|oro|dorad|gold|amarill/, 'linear-gradient(135deg,#f7e3a3,#c99a35)'],
      [/plata|platead|blanco|silver|acero|925|999/, 'linear-gradient(135deg,#fafafa,#b9bcc1)'],
      [/negro|black/, 'linear-gradient(135deg,#555,#111)'],
      [/gris/, 'linear-gradient(135deg,#ddd,#9a9a9a)'],
      [/crema/, 'linear-gradient(135deg,#fff8ec,#e9d9bd)']
    ];
    const colorDe = (v) => { const n = norm(v); const c = COLORES.find(([re]) => re.test(n)); return c ? c[1] : null; };
    const minimo = Math.min.apply(null, datos.variantes.map((v) => v.precio));
    pasos.forEach((paso) => {
      const pos = Number(paso.dataset.opcion) - 1;
      const nombre = norm(paso.dataset.opcionNombre);
      const opts = $$('.opt', paso);
      const valores = opts.map((o) => $('input', o).value);
      // Imagen por valor (de la variante con ese valor)
      const imgDe = (val) => { const v = datos.variantes.find((x) => x.opciones[pos] === val && x.imagen); return v ? v.imagen : null; };
      const imgsFijas = {};
      Object.keys(datos.imagenesOpciones || {}).forEach((k) => { imgsFijas[norm(k)] = datos.imagenesOpciones[k]; });
      const chip = valores.length > 0 && valores.every((v) => imgsFijas[norm(v)]);
      const imgs = chip ? valores.map((v) => imgsFijas[norm(v)]) : valores.map(imgDe);
      const conImagen = chip || (/caja|estuche|empaque|forma|estilo|impresion/.test(nombre) && imgs.every(Boolean) && new Set(imgs).size === imgs.length);
      if (chip) $('[data-opts]', paso).classList.add('opts--chip');
      const conColor = !conImagen && /metal|color|acabado|material|tono/.test(nombre) && valores.every(colorDe);
      let filas = false;
      opts.forEach((opt, k) => {
        const valor = valores[k];
        const caja = $('span', opt);
        const conValor = datos.variantes.filter((v) => v.opciones[pos] === valor);
        const extra = conValor.length ? Math.min.apply(null, conValor.map((v) => v.precio)) - minimo : 0;
        if (conImagen) { opt.classList.add('opt--img'); caja.insertAdjacentHTML('afterbegin', '<img src="' + imgs[k] + '" alt="" loading="lazy">'); }
        if (conColor) { opt.classList.add('opt--color'); caja.insertAdjacentHTML('afterbegin', '<i class="opt__dot" style="background:' + colorDe(valor) + '"></i>'); }
        if (extra > 0 && datos.variantes.length <= 24) caja.insertAdjacentHTML('beforeend', ' <small>(+' + money(extra).replace(/\.00$/, '') + ')</small>');
        const d = desc[norm(valor)];
        if (d) { filas = true; caja.insertAdjacentHTML('beforeend', '<small>' + esc(d) + '</small>'); }
      });
      const caja = $('[data-opts]', paso);
      if (conImagen) caja.classList.add('opts--img');
      if (conColor) caja.classList.add('opts--color');
      if (filas) caja.classList.add('opts--rows');
    });

    const valorDeOpcion = (nombre) => {
      const p = pasos.find((x) => norm(x.dataset.opcionNombre) === norm(nombre));
      const r = p && $('input:checked', p);
      return r ? r.value : '';
    };
    const varianteActual = () => {
      const vals = pasos.map((p) => { const r = $('input:checked', p); return r ? r.value : null; });
      return datos.variantes.find((v) => vals.every((val, i) => val === null || v.opciones[i] === val)) || datos.variantes[0];
    };

    /* ---------- Campos de personalización ---------- */
    const campoHTML = (etiqueta, max, piedra, piedraEtq, id, ejemplo) =>
      '<div class="field"><label class="field__label" for="' + id + '">' + esc(etiqueta) + '</label>' +
      '<div class="field__input"><input id="' + id + '" type="text" maxlength="' + max + '" data-req data-label="' + esc(etiqueta) + '"' +
      ' placeholder="' + esc(ejemplo || '') + '" autocomplete="off"><span class="field__count"><span data-count>0</span>/' + max + '</span></div>' +
      '<p class="field__err" data-err>Escribe el nombre para continuar.</p></div>' +
      (piedra ? '<span class="field__label">' + esc(piedraEtq) + '</span>' + piedrasGrid(id + '-piedra', ' data-stones-for="' + id + '"') +
        '<p class="field__err" data-err-stone>Elige una piedra de nacimiento para continuar.</p>' : '');
    const piedrasHTML = (etiqueta, id) => '<span class="field__label">' + esc(etiqueta) + '</span>' + piedrasGrid(id, ' data-stones-sola data-label="' + esc(etiqueta) + '"');
    const fotoHTML = (etiqueta, id, obligatoria) =>
      '<div class="field"><label class="field__label" for="' + id + '">' + esc(etiqueta) + (obligatoria ? '' : ' <span style="text-transform:none;letter-spacing:0">(opcional)</span>') + '</label>' +
      '<label class="file-pick"><input id="' + id + '" type="file" accept="image/*" data-foto data-label="' + esc(etiqueta) + '"' + (obligatoria ? ' data-req-foto' : '') + '>' +
      '<span data-file-name>Elegir foto</span></label></div>';

    /* Vista previa del grabado: una placa por nombre, con el acabado y el tipo de letra elegidos */
    /* Vista previa con foto real: una foto por acabado y número de nombres, con cada nombre colocado sobre su placa */
    const configs = {};
    const cargarConfig = (url) => (configs[url] = configs[url] || fetch(url).then((r) => r.json()).catch(() => null));
    function pintarEscena(b, esc) {
      const panel = $('[data-vista]', b);
      if (panel && panel.hidden) return;
      cargarConfig(esc.dataset.config).then((cfg) => {
        if (!cfg) return;
        const acabado = norm(valorDeOpcion(b.dataset.acabado || 'Acabado'));
        const tono = acabado.indexOf('negro') > -1 ? 'negro' : acabado.indexOf('dorad') > -1 || acabado.indexOf('oro') > -1 ? 'dorado' : 'plateado';
        const ins = $$('input[data-req]', b);
        const e = cfg.escenas[tono + '-' + Math.max(1, ins.length)];
        if (!e) return;
        const img = $('[data-vista-img]', esc);
        const src = esc.dataset.config.replace(/[^/]+\.json(\?.*)?$/, e.img);
        if (img.getAttribute('src') !== src) img.src = src;
        const letra = $('[data-letra] input:checked', b);
        const fuente = letra && /century/i.test(letra.value) ? "'Grabado Century', Georgia, serif" : "'Grabado Gothic', 'Century Gothic', sans-serif";
        const capas = $('[data-vista-capas]', esc);
        capas.innerHTML = e.placas.map((p, k) => {
          const txt = ins[k] ? ins[k].value.trim() : '';
          return '<span class="vista__nombre" style="left:' + p.x + '%;top:' + p.y + '%;width:' + p.w + '%;height:' + p.h + '%;transform:translate(-50%,-50%) rotate(' + p.r + 'deg);color:' + e.color + ';font-family:' + fuente + '"><b>' + esc_(txt) + '</b></span>';
        }).join('');
        const ajustar = () => $$('.vista__nombre', capas).forEach((s) => {
          const t = s.firstChild; t.style.transform = '';
          const max = s.clientWidth * 0.9;
          if (t.scrollWidth > max) t.style.transform = 'scale(' + (max / t.scrollWidth) + ')';
        });
        ajustar();
        if (document.fonts) document.fonts.ready.then(ajustar);
      });
    }
    const esc_ = (s) => esc(s);

    function pintarVista(b) {
      const escena = $('[data-vista-escena]', b);
      if (escena) { pintarEscena(b, escena); return; }
      const placas = $('[data-vista-placas]', b);
      if (!placas) return;
      const acabado = norm(valorDeOpcion(b.dataset.acabado || 'Acabado'));
      const tono = acabado.indexOf('negro') > -1 ? 'negro' : acabado.indexOf('dorad') > -1 || acabado.indexOf('oro') > -1 ? 'dorado' : 'plata';
      const letra = $('[data-letra] input:checked', b);
      const clase = letra ? 'letra--' + norm(letra.value).replace(/[^a-z0-9]+/g, '-') : '';
      placas.className = 'vista__placas vista__placas--' + tono + ' ' + clase;
      placas.innerHTML = $$('input[data-req]', b).map((i, k) => '<span class="vista__placa">' + esc(i.value.trim() || 'NOMBRE ' + (k + 1)) + '</span>').join('');
    }
    persos.forEach((b) => {
      $$('[data-letra] input', b).forEach((r) => r.addEventListener('change', () => {
        const a = $('[data-letra-actual]', b); if (a) a.textContent = r.value;
        pintarVista(b);
      }));
      const vb = $('[data-vista-btn]', b);
      if (vb) vb.addEventListener('click', () => {
        const p = $('[data-vista]', b); p.hidden = !p.hidden;
        vb.setAttribute('aria-expanded', String(!p.hidden));
        vb.textContent = p.hidden ? 'Ver cómo queda' : 'Ocultar vista previa';
        pintarVista(b);
      });
    });

    function pintarPerso() {
      persos.forEach((b, bi) => {
        const modo = b.dataset.modo, max = Number(b.dataset.max) || 20, piedra = b.dataset.piedra === 'true';
        const cont = $('[data-campos]', b);
        let etiquetas;
        if (modo === 'por_opcion') {
          const n = Math.max(1, parseInt((valorDeOpcion(b.dataset.opcionRef).match(/\d+/) || ['1'])[0], 10));
          etiquetas = Array.from({ length: n }, (_, i) => (b.dataset.etiquetaN || 'Nombre {n}').replace('{n}', i + 1));
        } else {
          etiquetas = (b.dataset.etiquetas || '').split(',').map((s) => s.trim()).filter(Boolean);
          if (modo === 'condicional') {
            const val = norm(valorDeOpcion(b.dataset.opcionRef));
            b.hidden = !(val && val.indexOf(norm(b.dataset.valorRef || 'si')) > -1);
          }
        }
        const firma = etiquetas.join('|');
        if (cont.dataset.firma === firma) { pintarVista(b); return; }
        const previos = {};
        $$('input[data-req]', cont).forEach((i) => { previos[i.dataset.label] = i.value; });
        cont.dataset.firma = firma;
        const id = (i) => 'p' + bi + '-' + i;
        if (modo === 'piedras') cont.innerHTML = etiquetas.map((e, i) => piedrasHTML(e, id(i))).join('');
        else if (modo === 'fotos') cont.innerHTML = etiquetas.map((e, i) => fotoHTML(e, id(i), i === 0)).join('');
        else cont.innerHTML = etiquetas.map((e, i) => campoHTML(e, max, piedra, b.dataset.piedraEtiqueta, id(i), b.dataset.ejemplo)).join('');
        const mayus = b.dataset.mayus === 'true';
        $$('input[data-req]', cont).forEach((i) => {
          if (previos[i.dataset.label]) i.value = previos[i.dataset.label];
          if (mayus) i.style.textTransform = 'uppercase';
          const c = $('[data-count]', i.parentElement);
          c.textContent = i.value.length;
          i.addEventListener('input', () => {
            if (mayus) { const p = i.selectionStart; i.value = i.value.toLocaleUpperCase('es-MX'); i.setSelectionRange(p, p); }
            c.textContent = i.value.length; i.closest('.field').classList.remove('is-invalid'); pintarVista(b);
          });
        });
        pintarVista(b);
        $$('.stones', cont).forEach((w) => w.addEventListener('change', () => { w.classList.remove('is-invalid'); const e = w.nextElementSibling; if (e && e.matches('[data-err-stone]')) e.classList.remove('is-on'); }));
        $$('[data-foto]', cont).forEach((i) => i.addEventListener('change', () => {
          const caja = i.closest('.file-pick');
          $('[data-file-name]', caja).textContent = i.files[0] ? i.files[0].name : 'Elegir foto';
          caja.classList.toggle('has-file', !!i.files[0]);
          caja.classList.remove('is-invalid');
        }));
      });
    }

    /* ---------- Extras (tarjeta con mensaje, bolsa) y total ---------- */
    extras.forEach((x) => {
      const t = $('[data-extra-toggle]', x);
      const msg = $('.extra__msg', x);
      t.addEventListener('change', () => {
        x.classList.toggle('is-on', t.checked);
        if (msg) { msg.hidden = !t.checked; if (t.checked) $('textarea', msg).focus(); }
        total();
      });
      if (msg) {
        const ta = $('textarea', msg), c = $('[data-count]', msg);
        ta.addEventListener('input', () => { c.textContent = ta.value.length; msg.classList.remove('is-invalid'); });
      }
    });
    function total() {
      const v = varianteActual();
      const suma = v.precio + extras.reduce((a, x) => a + ($('[data-extra-toggle]', x).checked ? Number(x.dataset.extraPrice) : 0), 0);
      const el = $('[data-total]', root);
      if (el) el.textContent = money(suma);
    }

    /* ---------- Entrega estimada en días hábiles ---------- */
    const ent = $('[data-delivery]', root);
    if (ent) {
      const sumarHabiles = (dias) => { const d = new Date(); let n = 0; while (n < dias) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) n++; } return d; };
      const a = sumarHabiles(Number(ent.dataset.min)), b = sumarHabiles(Number(ent.dataset.max));
      const adel = Number(ent.dataset.adelanto) || 0;
      a.setDate(a.getDate() - adel); b.setDate(b.getDate() - adel);
      const mes = (d) => d.toLocaleDateString('es-MX', { month: 'long' });
      const rango = a.getMonth() === b.getMonth() ? 'del ' + a.getDate() + ' al ' + b.getDate() + ' de ' + mes(b) : 'del ' + a.getDate() + ' de ' + mes(a) + ' al ' + b.getDate() + ' de ' + mes(b);
      $('[data-delivery-text]', ent).innerHTML = 'Pídelo hoy · Te llega <strong>' + rango + '</strong>';
    }

    /* ---------- Precio, ahorro, disponibilidad e imagen ---------- */
    function actualizar() {
      const v = varianteActual();
      idInput.value = v.id;
      const hay = v.comparar > v.precio;
      $$('[data-price]').forEach((e) => { e.textContent = money(v.precio); });
      $$('[data-compare]').forEach((e) => { e.textContent = money(v.comparar); e.hidden = !hay; });
      const save = $('[data-save]', root);
      if (save) {
        save.hidden = !hay;
        if (hay) {
          const ahorro = v.comparar - v.precio;
          save.innerHTML = '<svg viewBox="0 0 14 14" width="12" height="12" aria-hidden="true"><path d="M7.6 1.2l5.2 5.2c.4.4.4 1 0 1.4l-5 5c-.4.4-1 .4-1.4 0L1.2 7.6A.9.9 0 011 7.1V2c0-.6.4-1 1-1h5.1c.2 0 .4.1.5.2z" fill="none" stroke="currentColor" stroke-width="1.2"/><circle cx="4.2" cy="4.2" r="1" fill="currentColor"/></svg> Ahorras un ' + Math.round(ahorro / v.comparar * 100) + ' % (' + money(ahorro) + ')';
        }
      }
      btn.disabled = !v.disponible;
      $('[data-atc-label]', btn).textContent = v.disponible ? 'Agregar al carrito' : 'Agotado';
      if (v.media) irAMedia(v.media);
      if (pasos.length) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
      pintarPerso();
      total();
    }
    pasos.forEach((p) => p.addEventListener('change', actualizar));

    /* ---------- Validar y agregar (producto + extras) ---------- */
    function validar() {
      let primero = null;
      const marcar = (el) => { primero = primero || el; };
      $$('[data-perso]:not([hidden]) input[data-req]', root).forEach((i) => { if (!i.value.trim()) { i.closest('.field').classList.add('is-invalid'); marcar(i); } });
      $$('[data-perso]:not([hidden]) .stones', root).forEach((w) => {
        if (!$('input:checked', w)) { w.classList.add('is-invalid'); const e = w.nextElementSibling; if (e && e.matches('[data-err-stone]')) e.classList.add('is-on'); marcar(w); }
      });
      $$('[data-perso]:not([hidden]) [data-req-foto]', root).forEach((i) => { if (!i.files.length) { const c = i.closest('.file-pick'); c.classList.add('is-invalid'); marcar(c); } });
      extras.forEach((x) => {
        const msg = $('.extra__msg', x);
        if (msg && $('[data-extra-toggle]', x).checked && !$('textarea', msg).value.trim()) { msg.classList.add('is-invalid'); marcar($('textarea', msg)); }
      });
      const err = $('[data-error]', root);
      if (primero) {
        err.textContent = 'Revisa los campos marcados para continuar.';
        err.hidden = false;
        primero.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (primero.focus) primero.focus({ preventScroll: true });
        return false;
      }
      err.hidden = true;
      return true;
    }
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (btn.disabled || !validar()) return;
      const props = {};
      $$('[data-perso]:not([hidden]) input[data-req]', root).forEach((i) => {
        const w = $('[data-stones-for="' + i.id + '"] input:checked', root);
        props[i.dataset.label] = i.value.trim();
        if (w) props[($('[data-stones-for="' + i.id + '"]', root).previousElementSibling || {}).textContent || 'Piedra'] = w.value;
      });
      $$('[data-perso]:not([hidden]) [data-stones-sola]', root).forEach((w) => { props[w.dataset.label] = $('input:checked', w).value; });
      $$('[data-perso]:not([hidden]) [data-letra]', root).forEach((w) => { const r = $('input:checked', w); if (r) props[w.dataset.label || 'Tipo de letra'] = r.value; });
      const items =[{ id: Number(idInput.value), quantity: 1, properties: props }];
      extras.forEach((x) => {
        if (!$('[data-extra-toggle]', x).checked) return;
        const it = { id: Number(x.dataset.variant), quantity: 1 };
        const ta = $('textarea', x);
        if (ta) it.properties = { Mensaje: ta.value.trim() };
        items.push(it);
      });
      const fotos = $$('[data-perso]:not([hidden]) [data-foto]', root).filter((i) => i.files.length);
      let fd = null;
      if (fotos.length) {
        fd = new FormData();
        fd.append('id', idInput.value);
        fd.append('quantity', '1');
        Object.keys(props).forEach((k) => fd.append('properties[' + k + ']', props[k]));
        fotos.forEach((i) => fd.append('properties[' + i.dataset.label + ']', i.files[0]));
      }
      carrito.agregar(items, btn, { formData: fd });
    });
    const comprarDesdeAbajo = () => { form.scrollIntoView({ behavior: 'smooth', block: 'start' }); setTimeout(() => form.requestSubmit(), 450); };

    /* ---------- Galería ---------- */
    const track = $('[data-track]', root);
    const marcarFoto = (i) => {
      $$('[data-thumb]', root).forEach((b) => b.classList.toggle('is-active', Number(b.dataset.thumb) === i));
      const t = $('[data-thumb="' + i + '"]', root);
      if (t && !escritorio()) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };
    const escritorio = () => matchMedia('(min-width: 1000px)').matches;
    function irA(i) {
      const item = $('[data-item="' + i + '"]', root);
      if (!item) return;
      if (escritorio()) item.scrollIntoView({ behavior: 'smooth', block: 'center' });
      else track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      marcarFoto(i);
    }
    function irAMedia(mediaId) {
      const item = $('[data-media-id="' + mediaId + '"]', root);
      if (item && !escritorio()) irA(Number(item.dataset.item));
      else if (item) marcarFoto(Number(item.dataset.item));
    }
    $$('[data-thumb]', root).forEach((b) => b.addEventListener('click', () => irA(Number(b.dataset.thumb))));
    let ultimo = -1;
    track.addEventListener('scroll', () => {
      if (escritorio()) return;
      const i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== ultimo) { ultimo = i; marcarFoto(i); }
    }, { passive: true });
    const vistos = new Set();
    const io = new IntersectionObserver((es) => {
      es.forEach((en) => { const i = Number(en.target.dataset.item); if (en.isIntersecting) vistos.add(i); else vistos.delete(i); });
      if (vistos.size && escritorio()) marcarFoto(Math.min.apply(null, Array.from(vistos)));
    }, { threshold: 0.6 });
    $$('[data-item]', root).forEach((i) => io.observe(i));
    marcarFoto(0);

    // Zoom
    const lb = $('[data-lightbox]'), lbImg = $('[data-lb-img]');
    const fotosGal = $$('[data-item] img', root);
    let lbi = 0;
    const grande = (img) => (img.currentSrc || img.src).replace(/([?&])width=\d+/, '$1width=2000');
    const lbShow = (i) => { lbi = (i + fotosGal.length) % fotosGal.length; lbImg.src = grande(fotosGal[lbi]); };
    const lbClose = () => { lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); document.body.classList.remove('no-scroll'); };
    fotosGal.forEach((im, i) => { im.style.cursor = 'zoom-in'; im.addEventListener('click', () => { lbShow(i); lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll'); }); });
    $('[data-lb-close]').addEventListener('click', lbClose);
    lb.addEventListener('click', (e) => { if (e.target === lb) lbClose(); });
    $$('[data-lb]').forEach((b) => b.addEventListener('click', () => lbShow(lbi + Number(b.dataset.lb))));
    document.addEventListener('keydown', (e) => {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') lbClose();
      if (e.key === 'ArrowLeft') lbShow(lbi - 1);
      if (e.key === 'ArrowRight') lbShow(lbi + 1);
    });

    // Barra fija de compra
    const bar = $('[data-sticky]');
    if (bar) {
      new IntersectionObserver(([e]) => {
        const v = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', v);
        bar.setAttribute('aria-hidden', String(!v));
      }).observe(btn);
      $('[data-sticky-btn]', bar).addEventListener('click', comprarDesdeAbajo);
    }

    actualizar();
  }
})();
